import React from "react";
import ModalNotification from "../ModalNotification";
import styled from "styled-components";
import Button from "../Button";

const NotificationError = ({ isOpen = false, errorMessage, onClose = () => {} }) => {
  return (
    <ModalNotification
      isOpen={isOpen}
      title="Transacción fallida"
      description={
        <WrapperMessage>
          <Message>Ocurrió un error</Message>
          {errorMessage && <Error>{errorMessage}</Error>}
        </WrapperMessage>
      }
      buttons={
        <>
          <ButtonStyled primary={true} text="Aceptar" onClick={onClose} />
        </>
      }
      type="error"
    />
  );
};

const Message = styled.div``;

const WrapperMessage = styled.div``;

const Error = styled.div`
  margin-top: 30px;
`;

const ButtonStyled = styled(Button)`
  .button {
    background-color: #f44336;
  }
`;

export default NotificationError;
